function SocialXFrame() {
  return (
    <div className="z-50 bg-[#090910]">
      <svg
        width={219}
        height={224}
        viewBox="0 0 219 224"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_bi_169_3645)">
          <path
            d="M218 223V1H50.5L1 47.5V223H218Z"
            fill="#090910"
            fillOpacity="0.6"
          />
          <path
            d="M218 223V1H50.5L1 47.5V223H218Z"
            stroke="#22222F"
            strokeWidth="1.5"
          />
        </g>
        <g clipPath="url(#clip0_169_3645)">
          <path
            d="M120.952 110.846L155.951 71.0059H147.66L117.258 105.592L92.9932 71.0059H65L101.701 123.311L65 165.084H73.2908L105.376 128.553L131.007 165.084H159M76.2831 77.1284H89.0201L147.654 159.262H134.914"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_bi_169_3645"
            x="-71.85"
            y="-71.85"
            width="362.7"
            height="367.7"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="36.05" />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_169_3645"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_backgroundBlur_169_3645"
              result="shape"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy={-7} />
            <feGaussianBlur stdDeviation="8.8" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.145098 0 0 0 0 0.537255 0 0 0 0 1 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="shape"
              result="effect2_innerShadow_169_3645"
            />
          </filter>
          <clipPath id="clip0_169_3645">
            <rect
              width={94}
              height="94.0787"
              fill="white"
              transform="translate(65 71.0059)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>


  );
}

export default SocialXFrame;